import { ApolloClient } from 'apollo-client'
import { InMemoryCache, defaultDataIdFromObject } from 'apollo-cache-inmemory'
import { WebSocketLink } from 'apollo-link-ws'
import { onError } from 'apollo-link-error'
import { ApolloLink, split } from 'apollo-link'
import { getMainDefinition } from 'apollo-utilities'
import qs from 'query-string'

import { createUploadLink } from 'apollo-upload-client'

import createCalendarResolver from './modules/calendar/resolvers'

import { logError } from './common/utils/logging'
import { message } from 'antd'
import { SubscriptionClient } from 'subscriptions-transport-ws'

function getImpt() {
	let { impt } = qs.parse(window.location.search)

	if (impt) {
		window.sessionStorage.impt = impt

		return impt
	}

	return window.sessionStorage.impt
}

export const impt = getImpt()

export const cache = new InMemoryCache({
	dataIdFromObject: (object) => {
		switch (object.__typename) {
			case 'UploadedPhoto':
				return `UploadedPhoto:${object.key || object.url}`
			case 'Service':
				// Needed to make the service unique. Appointment's use a Service that has a price/duration. If we don't set this then apollo caches the service with the wrong price/duration info.
				return `Service:${object.id}-${object.sourceId}`
			case 'Source':
				// Needed to make sources unique, serviceId is required.
				return `Source:${object.id}-${object.serviceId}.${object.type}`
			default:
				return defaultDataIdFromObject(object) // fall back to default handling
		}
	},
})

const errorLink = onError(({ graphQLErrors, networkError }) => {
	if (graphQLErrors && graphQLErrors.length > 0) {
		graphQLErrors.forEach((error) => {
			if (error.name !== 'NotYourEntityError') {
				message.error(error.message)
			}
		})
	}

	if (networkError && networkError.result && networkError.result.errors) {
		networkError.result.errors.forEach(logError)
	}
})

let headers = {}

if (impt) {
	headers['X-NWIMPT'] = impt
}

const httpLink = ApolloLink.from([
	errorLink,
	createUploadLink({
		credentials: 'include',
		uri: process.env.REACT_APP_API_ENDPOINT,
		headers,
	}),
])

const subClient = new SubscriptionClient(process.env.REACT_APP_WSS_ENDPOINT, {
	credentials: 'include',
	reconnect: true,
	lazy: true,
})

subClient.on('connected', () => console.log('socket connected'))
subClient.on('disconnected', () => console.log('socket disconnected'))
subClient.on('reconnecting', () => console.log('socket reconnecting'))
subClient.on('reconnected', () => console.log('socket reconnected'))

export const wsLink = new WebSocketLink(subClient)

// using the ability to split links, you can send data to each link
// depending on what kind of operation is being sent
const link = split(
	// split based on operation type
	({ query }) => {
		const { kind, operation } = getMainDefinition(query)
		return kind === 'OperationDefinition' && operation === 'subscription'
	},
	wsLink,
	httpLink
)

const client = new ApolloClient({
	link,
	cache,
	resolvers: {
		...createCalendarResolver({ cache }),
	},
})

export default client
